import { render, staticRenderFns } from "./PageInfoWebsiteUnit.vue?vue&type=template&id=2db0c736&"
import script from "./PageInfoWebsiteUnit.vue?vue&type=script&lang=js&"
export * from "./PageInfoWebsiteUnit.vue?vue&type=script&lang=js&"
import style0 from "./PageInfoWebsiteUnit.vue?vue&type=style&index=0&id=2db0c736&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports